<template>
  <div class="pdf-page">
    <my-breadcrumb :items="pagination" ref="breadcrumb"></my-breadcrumb>
    <div class="dashboard-page-container">
      <h4>{{pdf.name}}</h4>

      <div class="pdf-container">
        <object
          :data="pdf.url"
          type="application/pdf"
          width="100%"
          :height="pdfHeight"
          class="left-scroll"
        ></object>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      pagination: [],
      pdfHeight: "200px",
      pdf: {}
    };
  },
  watch: {
    $route: function(newVal) {
      this.getDetail();
    }
  },
  mounted() {
    this.pdfHeight =
      window.innerHeight - 211 - this.$refs.breadcrumb.getHeight() + "px";
    console.log(this.$refs.breadcrumb.getHeight());

    this.$nextTick(function() {
      window.addEventListener("resize", this.myEventHandler);
    });

    if(this.isLoggedIn) {
      this.getDetail();
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    ...mapActions({
      getContentDetail: types.GET_CONTENT_DETAIL
    }),
    getDetail() {
      this.getContentDetail(this.$route.params.id)
      .then(response => {
        this.pdf = response[0];
        this.pagination = [
          {
            text: response[0].level,
            url: '#'
          },
          {
            text: response[0].class + " "+ response[0].major ? response[0].class : "",
            url: '#'
          },
          {
            text: response[0].subject,
            url: '#'
          },
          {
            text: response[0].curriculum,
            url: '#'
          },
          {
            text: response[0].chapter,
            url: '#'
          },{
            text: response[0].section,
            url: '#'
          }
        ];
      }).catch(error => {
        this.showMessageBox(error, "Failed to get contents", "danger");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    },
    myEventHandler() {
      this.pdfHeight =
        window.innerHeight - 221 - this.$refs.breadcrumb.getHeight() + "px";
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  }
};
</script>

<style></style>
